<div style="width: 100%;">
  <canvas #chart id="horseStrides" width="250" height="250"></canvas>
</div>
